import { render, staticRenderFns } from "./roleTempPermissionView.vue?vue&type=template&id=68c99cb0&"
import script from "./roleTempPermissionView.vue?vue&type=script&lang=js&"
export * from "./roleTempPermissionView.vue?vue&type=script&lang=js&"
import style0 from "./roleTempPermissionView.vue?vue&type=style&index=0&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports